export const STOREFRONT_CHECKOUT_THEME_ROUTE = '/stores/[cName]/checkout';
export const ISOLATED_PLUS_CHECKOUT_ROUTE = '/checkouts/[dispensaryId]/[checkoutId]';

export function isStorefrontCheckoutThemeRoute(route: string | null | undefined): boolean {
  return route === STOREFRONT_CHECKOUT_THEME_ROUTE;
}

export function isCheckoutOwnedRoute(route: string | null | undefined): boolean {
  return isStorefrontCheckoutThemeRoute(route) || route === ISOLATED_PLUS_CHECKOUT_ROUTE;
}
